import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Category } from '../../../../shared/model/category.model';
import { CategoryService } from '../../../../shared/services/category.service';
import { ToastrService } from 'ngx-toastr';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { AgGridService } from 'src/app/shared/components/ag-grid/ag-grid.service';
import { Button, PopUpTitles } from 'src/app/shared/model/enum';

@Component({
  selector: 'app-add-editcategory',
  templateUrl: './add-editcategory.component.html',
  styleUrls: ['./add-editcategory.component.scss']
})
export class AddEditcategoryComponent implements OnInit {
  @Input() title: string = "Add";
  @Input() isAddValue: boolean;
  @Input() insertCategoryModel = new Category();
  enumButtonName = Button
  enumPopUpTitles = PopUpTitles;
  insertCategoryList: Category[] = [];

  constructor(public activeModal: NgbActiveModal, 
    public  categoryService: CategoryService,  
    public toaster: ToastrService,
    public tabService:TabsService,
    public agGridService: AgGridService,
  ) { }

  ngOnInit(): void {
  }

  addCategory(){
    console.log('category model', this.insertCategoryModel)
      this.categoryService.addCategoryService(this.insertCategoryModel).subscribe((res)=>{
        if (res.isSuccess == true) {
          this.toaster.success(res.message)
          this.activeModal.close(res)
        }
        else {
          this.toaster.error('Failed to add category')
        }
      })
  }

}
